import { useState, useEffect } from 'react';
import { Sort } from 'src/icons/Sort.icon';
import { useDispatch, useSelector } from 'react-redux';
import {
  filterConditionsApi,
  getConditionByIdAction,
  getConditionListAction,
} from 'src/modules/SuperAdmin/store/actions/condition.action';
import { Dropdown, Menu, Select, Tooltip } from 'antd';
import {
  ActionMenuIcon,
  BinIcon,
  EditAppointmentIcon,
  PlusIcon,
} from 'src/icons';
import { SuperAdminTable } from '../../../baseComponents/Table';
import { Button } from '../../../baseComponents';
import AddNewCondition from './AddNewCondition';
import { appointmentTypesAction } from 'src/store/actions/appointment.action';
import { getAllSpecialtyListAction } from 'src/modules/SuperAdmin/store/actions';
import EditCondition from './EditCondition';
import DeleteCondition from './DeleteCondition';

const ConditionPage = () => {
  const { getAllConditionsList, isLoading, conditionsDropdown } = useSelector(
    (state) => state?.conditionState
  );

  const tableData = Array.isArray(getAllConditionsList)
    ? getAllConditionsList
    : [];
  const [conditionOptions, setConditionOptions] = useState([]);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [conditionModalOpen, setConditionModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [isfilterOn, setIsFilterOn] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getConditionListAction());
    dispatch(appointmentTypesAction());
  }, [dispatch]);

  useEffect(() => {
    setTableLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (conditionsDropdown && Array.isArray(conditionsDropdown)) {
      let dataArr = [];
      conditionsDropdown.forEach((key) => {
        dataArr.push({
          value: key?.condition_id,
          label: key?.condition_name,
        });
      });
      dataArr?.unshift({ label: 'All', value: 'All' });
      setConditionOptions(dataArr);
    }
  }, [conditionsDropdown]);

  useEffect(() => {
    if (conditionsDropdown && Array.isArray(conditionsDropdown)) {
      const uniqueSpecialtyIds = {};
      const dataArr = [];
      conditionsDropdown.forEach((key) => {
        if (!uniqueSpecialtyIds[key.specialty_id]) {
          uniqueSpecialtyIds[key.specialty_id] = true;
          dataArr.push({
            value: key?.specialty_id,
            label: key?.specialty_name ? key?.specialty_name : 'N/A',
          });
        }
      });
      dataArr?.unshift({ label: 'All', value: 'All' });
      setSpecialtyOptions(dataArr);
    }
  }, [conditionsDropdown, getAllConditionsList]);

  const handleEditCondition = (condition_id) => {
    dispatch(getConditionByIdAction(condition_id, setEditModalOpen));
    dispatch(getAllSpecialtyListAction());
  };

  const handleDeleteCondition = (condition_id) => {
    dispatch(getConditionByIdAction(condition_id, setDeleteModalOpen));
  };

  const menu_options = (id, record) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editCondition') {
            handleEditCondition(id, record);
          }

          if (key === 'deleteCondition') {
            handleDeleteCondition(id, record);
          }
        }}
      >
        <Menu.Item key="editCondition">
          <div className="dropdown-text flex items-center space-x-2">
            <EditAppointmentIcon /> <span>Edit condition</span>
          </div>
        </Menu.Item>
        <Menu.Item key="deleteCondition">
          <div className="dropdown-text flex items-center space-x-2">
            <BinIcon /> <span>Remove condition</span>
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const condition_nameSorter = (a, b) => {
    return a.condition_name.localeCompare(b.condition_name);
  };

  const specialty_nameSorter = (a, b) => {
    return a.specialty_name.localeCompare(b.specialty_name);
  };

  const condition_type_nameSorter = (a, b) => {
    return a.condition_type.localeCompare(b.condition_type);
  };

  const columns = [
    {
      title: (
        <span className="font-[700] right-0">
          Condition name
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'condition_name',
      key: 'condition_name',
      sorter: tableData?.length > 0 && condition_nameSorter,
      render: (text, record) => {
        return (
          <span style={{ textTransform: 'capitalize' }}>
            {record?.condition_name || 'N/A'}
          </span>
        );
      },
    },
    {
      title: <span className="font-[700]">Description</span>,
      dataIndex: 'description',
      key: 'description',
      render: (text, record) => {
        return (
          <Tooltip title={record?.description}>
            <div
              style={{
                maxWidth: '200px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {record?.description}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: (
        <span className="font-[700]">
          Specialty name
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'specialty_name',
      key: 'specialty_name',
      sorter: tableData?.length > 0 && specialty_nameSorter,
      render: (text, record) => {
        return <span>{record?.specialty_name}</span>;
      },
    },
    {
      title: (
        <span className="font-[700]">
          Condition type
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'condition_type',
      key: 'condition_type',
      sorter: tableData?.length > 0 && condition_type_nameSorter,
      render: (text, record) => {
        return (
          <span style={{ textTransform: 'capitalize' }}>
            {record?.condition_type}
          </span>
        );
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      render: (text, record) => {
        return (
          <Dropdown overlay={menu_options(record?.condition_id, record)}>
            <a onClick={(e) => e.preventDefault()}>
              <ActionMenuIcon />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const initialFilterValue = {
    specialty_id: null,
    condition_id: null,
  };

  const [filterValue, setFilterValue] = useState(initialFilterValue);

  const filterHandler = (type, value) => {
    if (type === 'specialty') {
      if (value === 'All') {
        setFilterValue({
          ...filterValue,
          specialty_id: null,
        });
        if (filterValue?.condition_id === null) {
          setIsFilterOn(false);
          dispatch(getConditionListAction());
        } else {
          setIsFilterOn(true);
          dispatch(filterConditionsApi(null, filterValue?.condition_id));
        }
      } else {
        setFilterValue({
          ...filterValue,
          specialty_id: value,
        });
        setIsFilterOn(true);
        dispatch(filterConditionsApi(value, filterValue?.condition_id));
      }
    } else {
      if (value === 'All') {
        setFilterValue({
          ...filterValue,
          condition_id: null,
        });
        if (filterValue?.specialty_id === null) {
          setIsFilterOn(false);
          dispatch(getConditionListAction());
        } else {
          setIsFilterOn(true);
          dispatch(filterConditionsApi(filterValue?.specialty_id, null));
        }
      } else {
        setFilterValue({
          ...filterValue,
          condition_id: value,
        });
        setIsFilterOn(true);
        dispatch(filterConditionsApi(filterValue?.specialty_id, value));
      }
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row lg:justify-between justify-center items-center">
        <div className="flex flex-col sm:flex-row">
          <div className="flex justify-start gap-12 ">
            <div className="  bg-white shadow-sm rounded-xl w-60 flex items-center practitioner-dropdown">
              <Select
                style={{
                  placeholder: {
                    fontFamily: 'Poppins',
                    color: '#667085',
                  },
                }}
                bordered={false}
                className="border-none font-sans h-10 flex items-center  focus:outline-none w-full"
                optionFilterProp="label"
                placeholder="Search condition"
                showSearch
                options={conditionOptions}
                onChange={(e) => filterHandler('condition', e)}
                value={filterValue.condition_id}
                id="Condition_Id"
              ></Select>
            </div>
            <div className="bg-white shadow-sm rounded-xl w-60 flex items-center">
              <Select
                style={{
                  placeholder: {
                    fontFamily: 'Poppins',
                    color: '#667085',
                  },
                }}
                bordered={false}
                className="border-none font-sans h-10 flex items-center  focus:outline-none w-full"
                optionFilterProp="label"
                placeholder="Search specialty"
                showSearch
                options={specialtyOptions}
                onChange={(e) => filterHandler('specialty', e)}
                value={filterValue.specialty_id}
                id="Specialty_Id"
              ></Select>
            </div>
          </div>
        </div>
        <div className="flex justify-end items-end">
          <Button
            type={'button'}
            onClick={() => {
              setConditionModalOpen(true);
              dispatch(getAllSpecialtyListAction());
            }}
          >
            <PlusIcon className={`mr-2`} /> Add condition
          </Button>
        </div>
      </div>
      <div>
        <div className="mt-5 ant-table rounded-xl shadow-xl">
          <SuperAdminTable
            className={'appointment-page-table'}
            data={tableData}
            columns={columns}
            loading={tableLoader}
          />
        </div>
      </div>

      {/* All modals constructed here */}
      <AddNewCondition
        isOpen={conditionModalOpen}
        setIsOpen={setConditionModalOpen}
        isfilterOn={isfilterOn}
        filterValue={filterValue}
      />

      <EditCondition
        isOpen={editModalOpen}
        setIsOpen={setEditModalOpen}
        isfilterOn={isfilterOn}
        filterValue={filterValue}
      />

      <DeleteCondition
        isOpen={deleteModalOpen}
        setIsOpen={setDeleteModalOpen}
        isfilterOn={isfilterOn}
        filterValue={filterValue}
      />
    </div>
  );
};

export default ConditionPage;
